import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a4170c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "creation__container items-center justify-center" }
const _hoisted_2 = { class: "fixed inset-0 z-20 sm:relative sm:aspect-[9/16] sm:w-[calc(375px+5vw)] sm:rounded-[calc(20px+0.025vw)] w-full overflow-hidden shadow-[0px_3px_9px_rgba(0,0,0,0.1)]" }
const _hoisted_3 = {
  key: 0,
  class: "absolute inset-x-0 top-0 z-30 sm:hidden"
}
const _hoisted_4 = {
  key: 1,
  class: "absolute top-0 inset-x-0 z-30"
}
const _hoisted_5 = { class: "p-4 flex items-center justify-between gap-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "button__icon text-white" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#skip" })
], -1))
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = {
  class: "w-7 h-7 -rotate-90 relative z-10",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-7 h-7 absolute inset-0",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "18",
    cy: "18",
    r: "16.5",
    class: "stroke-[3] stroke-black/60"
  })
], -1))
const _hoisted_10 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center bg-black z-30"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "w-[calc(80px+0.6vw)] h-[calc(80px+0.6vw)] rounded-full bg-white flex items-center justify-center shadow-2xl"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "icon w-[calc(40px+0.6vw)] h-[calc(40px+0.6vw)] text-black playscale" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#play" })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  ref: "video",
  class: "object-cover w-full h-full transform-gpu",
  playsinline: ""
}
const _hoisted_17 = ["src", "type"]
const _hoisted_18 = {
  key: 0,
  class: "absolute inset-x-0 bottom-0 z-30 sm:hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SurveyHeaderComponent = _resolveComponent("SurveyHeaderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!_ctx.didStartPlaying)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_SurveyHeaderComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "button button--small bg-black/60 text-white",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToNextScreen && _ctx.goToNextScreen(...args)))
                  }, [
                    _createTextVNode(" Skip "),
                    _hoisted_6
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                      _createElementVNode("circle", {
                        cx: "18",
                        cy: "18",
                        r: "16.5",
                        class: "creation__progress-circle-video",
                        style: _normalizeStyle(`--percent: ${_ctx.playbackDuration}`)
                      }, null, 4)
                    ])),
                    _hoisted_9
                  ])
                ])
              ]))
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!_ctx.videoLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["bg-black/40 absolute z-20 inset-0 flex items-center justify-center transition cursor-pointer", { '!bg-black/0': _ctx.isVideoPlaying }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleVideoPlayback && _ctx.toggleVideoPlayback(...args)))
      }, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (!_ctx.isVideoPlaying)
              ? (_openBlock(), _createElementBlock("button", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("video", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video) => {
          return (_openBlock(), _createElementBlock("source", {
            key: video.url,
            src: video.url,
            type: video.type
          }, null, 8, _hoisted_17))
        }), 128)),
        _createTextVNode(" Your browser does not support the video tag. ")
      ], 512),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!_ctx.isVideoPlaying)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_FooterComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}